<div class="resetprogress">
    Are you sure that you want to reset all your progress and start over?
    <div class="buttons">
        <button class="themed" @click="reset">Yes, reset and start over</button>
        <button class="themed" @click="cancel">No</button>
    </div>
</div>
